import { Nullable } from 'types/utils';

export const isEmpty = (obj: Nullable<object>) => !!(obj && Object.keys(obj).length === 0);
